/* eslint-disable arrow-body-style */
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ValidationDialog = ({ open, onClose, validationResp = [] }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between', // space between title and close button
                    color: '#d84315',
                    gap: 1
                }}
            >
                <Typography variant="h3" component="span" sx={{ fontWeight: 500 }}>
                    Action Required
                </Typography>

                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {validationResp.length > 0 ? (
                    <Box component="ol" sx={{ pl: 0, m: 0 }}>
                        {validationResp.map((msg, index) => (
                            <Box
                                key={index}
                                component="li"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    mb: 1.5,
                                    p: 1,
                                    borderRadius: 1,
                                    backgroundColor: '#fff4e5', // soft warning background
                                    color: '#663c00' // warning text color
                                }}
                            >
                                <Typography variant="body1" component="span">
                                    {index + 1}. {msg}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                ) : (
                    <Typography variant="body2">No validation issues.</Typography>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ValidationDialog;
